import { render, staticRenderFns } from "./Prospectors.vue?vue&type=template&id=182b6dd2&scoped=true"
import script from "./Prospectors.vue?vue&type=script&lang=js"
export * from "./Prospectors.vue?vue&type=script&lang=js"
import style0 from "./Prospectors.vue?vue&type=style&index=0&id=182b6dd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182b6dd2",
  null
  
)

export default component.exports